import { useState, useRef } from "react";
import { Button, Form, Alert, Spinner } from "react-bootstrap";
import { FaInstagram, FaYoutube } from 'react-icons/fa';
import RowContent from "../../components/containers/row-content";
import { Link } from "react-router-dom";
import emailjs from '@emailjs/browser';
import SEO from "../../components/seo";

// Configure these values with your EmailJS account:
// 1. Create a free account at https://www.emailjs.com/
// 2. Create an Email Service (e.g., Gmail)
// 3. Create an Email Template with variables: {{from_name}}, {{from_email}}, {{message}}
// 4. Replace the values below with your own IDs
const EMAILJS_SERVICE_ID = 'YOUR_SERVICE_ID';
const EMAILJS_TEMPLATE_ID = 'YOUR_TEMPLATE_ID';
const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY';

const Contato = () => {
    const formRef = useRef();
    const [formData, setFormData] = useState({ from_name: '', from_email: '', message: '' });
    const [status, setStatus] = useState(null); // 'success' | 'error' | 'sending'
    const [validated, setValidated] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.currentTarget;

        if (!form.checkValidity()) {
            setValidated(true);
            return;
        }

        setStatus('sending');

        emailjs.sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, formRef.current, EMAILJS_PUBLIC_KEY)
            .then(() => {
                setStatus('success');
                setFormData({ from_name: '', from_email: '', message: '' });
                setValidated(false);
            })
            .catch(() => {
                setStatus('error');
            });
    };

    return (
        <div className="d-flex flex-column justify-content-center align-items-center py-4 main-responsive-height bg-white">
            <SEO
                title="Contato"
                description="Entre em contato com a Abdução Filmes. Envie sua mensagem ou nos encontre nas redes sociais."
                path="/contato"
            />
            <div className="container">
                <Form ref={formRef} noValidate validated={validated} onSubmit={handleSubmit}>
                    <RowContent>
                        <div className="col-md-6">
                            {status === 'success' && (
                                <Alert variant="success" onClose={() => setStatus(null)} dismissible>
                                    Mensagem enviada com sucesso!
                                </Alert>
                            )}
                            {status === 'error' && (
                                <Alert variant="danger" onClose={() => setStatus(null)} dismissible>
                                    Erro ao enviar mensagem. Tente novamente ou envie diretamente para contato@abducaofilmes.com.br.
                                </Alert>
                            )}
                            <Form.Group className="mb-3" controlId="formItemNome">
                                <Form.Control
                                    type="text"
                                    name="from_name"
                                    placeholder="Nome"
                                    value={formData.from_name}
                                    onChange={handleChange}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">Informe seu nome.</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formItemEmail">
                                <Form.Control
                                    type="email"
                                    name="from_email"
                                    placeholder="E-mail"
                                    value={formData.from_email}
                                    onChange={handleChange}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">Informe um e-mail válido.</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formItemMensagem">
                                <Form.Control
                                    as="textarea"
                                    name="message"
                                    rows={3}
                                    placeholder="Mensagem"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">Escreva sua mensagem.</Form.Control.Feedback>
                            </Form.Group>
                            <div className="d-grid">
                                <Button variant="dark" type="submit" disabled={status === 'sending'}>
                                    {status === 'sending' ? (
                                        <>
                                            <Spinner as="span" animation="border" size="sm" role="status" className="me-2" />
                                            Enviando...
                                        </>
                                    ) : 'Enviar'}
                                </Button>
                            </div>
                        </div>
                        <div className="col-md-6 text-center d-flex flex-column justify-content-center">
                            <div><h3>abducaofilmes@gmail.com</h3></div>
                            <div className="d-flex justify-content-center">
                                <div className="p-2 p-md-4"><Link to={"https://instagram.com/abducaofilmes"} target="_blank"><FaInstagram size={26} title="@abducaofilmes"></FaInstagram></Link></div>
                                <div className="p-2 p-md-4"><Link to={"https://www.youtube.com/@abducaofilmes"} target="_blank"><FaYoutube size={26} title="@abducaofilmes"></FaYoutube></Link></div>
                            </div>
                        </div>
                    </RowContent>
                </Form>
            </div>
        </div>
    );
}

export default Contato;
